// extracted by mini-css-extract-plugin
export default {"container":"Footer_container__GUml-","email":"Footer_email__UAaWP","xlogo":"Footer_xlogo__9E-ld","loading":"Footer_loading__kqZum"};